import { LocalShippingOutlined } from "@mui/icons-material";
import { globalTheme } from "../../styles";

export const ShipmentIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = globalTheme.primaryColor } = props;

  return (
    <LocalShippingOutlined style={{ width, height, fill }} />
  );
};
